<template>
  <div>
    <v-menu
      bottom
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          color="primary"
          large
          v-on="on"
        >
          <v-icon>
            mdi-menu-open
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="handleClick(index, item)"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon" />
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <dialog-delete
      v-if="dialogs.delete || closeDialog"
      @close="dialogs.delete = false"
      @delete="deleteItem"
    />
  </div>
</template>

<script>
import DialogDelete from "../dialog-delete/DialogDelete"

export default {
  name: "TaskMenu",
  components: { DialogDelete },
  props: {
    taskItems: {
      default: null
      }
},
  data: () => ({
    dialogs: {
      delete: false,
    },

    items: [
      {
        title: "Редактировать",
        icon: "mdi-pencil",
        click () {
          this.$emit("edit")
        },
      },
      {
        title: "Удалить",
        icon: "mdi-delete",
        click () {
          this.dialogs.delete = true
        },
      },
    ],
  }),
  computed: {
    closeDialog () {
      return this.dialogs.delete
    },
  },
    beforeMount () {
      if (this.taskItems) {
          this.items = this.taskItems
      }
    },
    methods: {
    handleClick (index, item) {
      this.items[index].click.call(this, item)
    },
    deleteItem () {
      this.dialogs.delete = false
      this.$emit("delete")
    },
  },
}
</script>

<style scoped></style>
